import React from "react";
import { Line } from "react-chartjs-2";
import SectionCard from "../shared/SectionCard";
import "../shared/chartSetup";

const DEFAULT_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        boxWidth: 8,
        font: { size: 10 },
        padding: 16,
        usePointStyle: true,
        pointStyleWidth: 8,
        color: "#667085",
      },
    },
    title: { display: false },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: { font: { size: 9 }, color: "#98A2B3" },
    },
    y: {
      display: false,
    },
  },
};

/**
 * Overview section: stat columns at the top + a filled line chart below.
 *
 * @param {string}  title
 * @param {{ label: string, value: string, change: string, up: boolean }[]} stats
 * @param {object}  chartData            Chart.js line data object
 * @param {object}  [chartOptions]       Replaces default options entirely when provided
 * @param {number}  [chartHeight=210]    Height of the chart area in px
 */
const OverviewSection = ({
  title,
  stats = [],
  chartData,
  chartOptions,
  chartHeight = 210,
}) => (
  <SectionCard title={title}>
    {/* Stat columns — label / large value / change badge */}
    <div
      className="d-flex flex-wrap gap-4 mb-4"
      style={{ borderBottom: "1px solid #F2F4F7", paddingBottom: "1rem" }}
    >
      {stats.map((s, i) => (
        <div key={i} style={{ minWidth: 80 }}>
          <div
            style={{ fontSize: "0.7rem", color: "#98A2B3", marginBottom: 2 }}
          >
            {s.label}
          </div>
          <div
            className="fw-bold"
            style={{ fontSize: "1.5rem", color: "#101828", lineHeight: 1.15 }}
          >
            {s.value}
          </div>
          <div
            className="d-flex align-items-center gap-1 mt-1"
            style={{
              fontSize: "0.7rem",
              color: s.up ? "#12B76A" : "#F04438",
              fontWeight: 600,
            }}
          >
            <span>{s.up ? "↑" : "↓"}</span>
            <span>{s.change}</span>
          </div>
        </div>
      ))}
    </div>

    {/* Line chart */}
    <div style={{ height: chartHeight }}>
      <Line
        data={chartData ?? { labels: [], datasets: [] }}
        options={chartOptions ?? DEFAULT_OPTIONS}
      />
    </div>
  </SectionCard>
);

export default OverviewSection;
